import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Box, Text } from '../basic';
import PageTitle from './PageTitle.layout';
import PageNavigation from './PageNavigation.layout';
import Flex from '../basic/Flex';
import { SMALLER_MAX_WIDTH } from '../../../../state/actions/constants/app.constants';

function Page({
  titulo,
  overrideMaxWidth,
  tituloTraduccionId,
  hasStickyActionsHeader,
  navigationItems,
  loading,
  loadingText,
  children,
  style,
}) {
  const getPageTitle = () => {
    if (React.isValidElement(titulo)) {
      return titulo;
    }
    return (titulo || tituloTraduccionId) ? <PageTitle hasStickyActionsHeader={hasStickyActionsHeader} texto={titulo} translationId={tituloTraduccionId} /> : null;
  };
  if (loading) {
    return (
      <>
        <style>{'.spinningBox .ant-spin-nested-loading{ width:100%; height:100%;} .spinningBox .ant-spin-nested-loading .ant-spin-blur{ display:none;}'}</style>
        <Box height="100%" className="spinningBox" p={['24']}>
          <Spin size="large" tip={loadingText} style={{ background: 'transparent' }}>
            <div />
          </Spin>
        </Box>
      </>
    );
  }
  return (
    <Flex id="page" alignItems="center" flexDirection="column">
      <Box
        id="page-content"
        style={{
          height: '100%', padding: '24px 24px 24px 24px', width: '100%', maxWidth: `${SMALLER_MAX_WIDTH}px`, ...style,
        }}
      >
        { navigationItems ? <Box mb="8"><PageNavigation items={navigationItems} /></Box> : null }
        { getPageTitle() }
        <Box style={!overrideMaxWidth ? { maxWidth: `${SMALLER_MAX_WIDTH}px` } : null}>
          { children }
        </Box>
      </Box>
    </Flex>
  );
}

Page.propTypes = {
  titulo: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  style: PropTypes.shape({}),
  tituloTraduccionId: PropTypes.string,
  loadingText: PropTypes.string,
  hasStickyActionsHeader: PropTypes.bool,
  loading: PropTypes.bool,
  overrideMaxWidth: PropTypes.bool,
  navigationItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Page.defaultProps = {
  titulo: '',
  style: {},
  tituloTraduccionId: undefined,
  loadingText: 'Cargando página',
  hasStickyActionsHeader: false,
  overrideMaxWidth: false,
  loading: false,
};
export default Page;
